import React from "react";
import { useLocation } from "react-router-dom";
import B2BHeader from "../../components/b2b/B2BHeader";

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }): JSX.Element => {
  const location = useLocation();
  
  // Public routes that don't need the B2B header
  const publicRoutes = [
    "/signin", 
    "/client-login", 
    "/login-client", 
    "/verify-mobile", 
    "/404",
    "/",
    "login-client"
  ];
  
  const isPublicRoute = publicRoutes.includes(location.pathname);
  
  return (
    <div>
      {/* Show B2BHeader for admin routes */}
      {/* {!isPublicRoute && <B2BHeader />} */}
      {children}
    </div>
  );
};

export default AdminLayout;
